"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDisplayEventsDto = exports.GetDisplayEventsQueryDto = exports.DisplayEventSearchFiltersDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const display_event_type_1 = require("../../../types/display-event.type");
class DisplayEventSearchFiltersDto {
    static normalizeEmptyString(value) {
        return !value ? undefined : value;
    }
    from;
    to;
    category;
    type;
    severity;
    source;
}
exports.DisplayEventSearchFiltersDto = DisplayEventSearchFiltersDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDateString)(),
    __metadata("design:type", String)
], DisplayEventSearchFiltersDto.prototype, "from", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDateString)(),
    __metadata("design:type", String)
], DisplayEventSearchFiltersDto.prototype, "to", void 0);
__decorate([
    (0, class_transformer_1.Transform)(({ value }) => DisplayEventSearchFiltersDto.normalizeEmptyString(value)),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(display_event_type_1.DISPLAY_EVENT_CATEGORIES),
    (0, class_validator_1.ValidateIf)((o) => o.category !== undefined),
    __metadata("design:type", String)
], DisplayEventSearchFiltersDto.prototype, "category", void 0);
__decorate([
    (0, class_transformer_1.Transform)(({ value }) => DisplayEventSearchFiltersDto.normalizeEmptyString(value)),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(display_event_type_1.DISPLAY_EVENT_TYPES),
    (0, class_validator_1.ValidateIf)((o) => o.type !== undefined),
    __metadata("design:type", String)
], DisplayEventSearchFiltersDto.prototype, "type", void 0);
__decorate([
    (0, class_transformer_1.Transform)(({ value }) => DisplayEventSearchFiltersDto.normalizeEmptyString(value)),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsIn)(display_event_type_1.DISPLAY_EVENT_SEVERITIES),
    (0, class_validator_1.ValidateIf)((o) => o.severity !== undefined),
    __metadata("design:type", String)
], DisplayEventSearchFiltersDto.prototype, "severity", void 0);
__decorate([
    (0, class_transformer_1.Transform)(({ value }) => DisplayEventSearchFiltersDto.normalizeEmptyString(value)),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateIf)((o) => o.source !== undefined),
    __metadata("design:type", String)
], DisplayEventSearchFiltersDto.prototype, "source", void 0);
class GetDisplayEventsQueryDto extends DisplayEventSearchFiltersDto {
    limit;
}
exports.GetDisplayEventsQueryDto = GetDisplayEventsQueryDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(1),
    (0, class_validator_1.Max)(500),
    __metadata("design:type", Number)
], GetDisplayEventsQueryDto.prototype, "limit", void 0);
class GetDisplayEventsDto extends DisplayEventSearchFiltersDto {
    displayId;
    limit;
}
exports.GetDisplayEventsDto = GetDisplayEventsDto;
